import React, { useState } from 'react';
import MainLayout from '../../components/layout/MainLayout';
import { MdSave, MdEdit, MdBusiness } from 'react-icons/md';
import '../master/MasterData.css';

interface CompanyInfo {
  companyName: string;
  businessName: string;
  tin: string;
  registrationNo: string;
  address: string;
  city: string;
  province: string;
  zipCode: string;
  country: string;
  phone: string;
  fax: string;
  email: string;
  website: string;
  sssNo: string;
  philHealthNo: string;
  pagibigNo: string;
  taxType: 'VAT' | 'NON-VAT';
  industryType: string;
  establishedDate: string;
  fiscalYearEnd: string;
  currency: string;
  logo: string;
}

const CompanyProfile: React.FC = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [companyInfo, setCompanyInfo] = useState<CompanyInfo>({
    companyName: 'DEWFOAM Manufacturing Corporation',
    businessName: 'DEWFOAM MFG CORP',
    tin: '123-456-789-000',
    registrationNo: 'SEC-2020-000123',
    address: '123 Industrial Park Road, Phase 2',
    city: 'Calamba',
    province: 'Laguna',
    zipCode: '4027',
    country: 'Philippines',
    phone: '+63 49 545 1234',
    fax: '+63 49 545 1235',
    email: 'info@dewfoam.com',
    website: 'www.dewfoam.com',
    sssNo: 'SS-1234567-8',
    philHealthNo: 'PH-123456789-0',
    pagibigNo: 'PG-123456789012',
    taxType: 'VAT',
    industryType: 'Furniture Manufacturing',
    establishedDate: '2020-01-15',
    fiscalYearEnd: '12-31',
    currency: 'PHP',
    logo: ''
  });

  const handleSave = () => {
    alert('Company profile saved successfully!');
    setIsEditing(false);
    // TODO: Save to API
  };

  const handleCancel = () => {
    setIsEditing(false);
    // TODO: Reload from API
  };

  return (
    <MainLayout>
      <div className="master-data-page">
        <div className="page-header">
          <div>
            <h2>Company Profile</h2>
            <p className="subtitle">Manage company information and tax registration details</p>
          </div>
          <div style={{ display: 'flex', gap: '10px' }}>
            {!isEditing ? (
              <button className="btn btn-primary" onClick={() => setIsEditing(true)}>
                <MdEdit /> Edit Profile
              </button>
            ) : (
              <>
                <button className="btn btn-secondary" onClick={handleCancel}>
                  Cancel
                </button>
                <button className="btn btn-primary" onClick={handleSave}>
                  <MdSave /> Save Changes
                </button>
              </>
            )}
          </div>
        </div>

        <div className="page-content">
          <div style={{
            padding: '30px',
            backgroundColor: '#fff',
            borderRadius: '8px',
            border: '1px solid #dee2e6'
          }}>
            {/* Company Logo Section */}
            <div style={{
              textAlign: 'center',
              padding: '30px',
              backgroundColor: '#f8f9fa',
              borderRadius: '8px',
              marginBottom: '30px'
            }}>
              <div style={{
                width: '150px',
                height: '150px',
                margin: '0 auto 20px',
                backgroundColor: '#1a237e',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff',
                fontSize: '48px'
              }}>
                <MdBusiness />
              </div>
              <h3 style={{ margin: '0 0 10px 0', color: '#1a237e' }}>{companyInfo.companyName}</h3>
              <p style={{ margin: 0, color: '#666' }}>{companyInfo.businessName}</p>
              {isEditing && (
                <button className="btn btn-secondary" style={{ marginTop: '15px' }}>
                  Upload Logo
                </button>
              )}
            </div>

            {/* Basic Information */}
            <h4 style={{ marginBottom: '20px', color: '#1a237e', borderBottom: '2px solid #1a237e', paddingBottom: '10px' }}>
              Basic Information
            </h4>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '30px' }}>
              <div className="form-group">
                <label>Company Name *</label>
                <input
                  type="text"
                  value={companyInfo.companyName}
                  onChange={(e) => setCompanyInfo({...companyInfo, companyName: e.target.value})}
                  disabled={!isEditing}
                />
              </div>
              <div className="form-group">
                <label>Business Name</label>
                <input
                  type="text"
                  value={companyInfo.businessName}
                  onChange={(e) => setCompanyInfo({...companyInfo, businessName: e.target.value})}
                  disabled={!isEditing}
                />
              </div>
              <div className="form-group">
                <label>Industry Type</label>
                <input
                  type="text"
                  value={companyInfo.industryType}
                  onChange={(e) => setCompanyInfo({...companyInfo, industryType: e.target.value})}
                  disabled={!isEditing}
                />
              </div>
              <div className="form-group">
                <label>Date Established</label>
                <input
                  type="date"
                  lang="en-US"
                  value={companyInfo.establishedDate}
                  onChange={(e) => setCompanyInfo({...companyInfo, establishedDate: e.target.value})}
                  disabled={!isEditing}
                />
              </div>
            </div>

            {/* Tax and Registration Information */}
            <h4 style={{ marginBottom: '20px', color: '#1a237e', borderBottom: '2px solid #1a237e', paddingBottom: '10px' }}>
              Tax and Registration Information
            </h4>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '30px' }}>
              <div className="form-group">
                <label>Tax Identification Number (TIN) *</label>
                <input
                  type="text"
                  value={companyInfo.tin}
                  onChange={(e) => setCompanyInfo({...companyInfo, tin: e.target.value})}
                  disabled={!isEditing}
                  placeholder="000-000-000-000"
                />
              </div>
              <div className="form-group">
                <label>SEC/DTI Registration No.</label>
                <input
                  type="text"
                  value={companyInfo.registrationNo}
                  onChange={(e) => setCompanyInfo({...companyInfo, registrationNo: e.target.value})}
                  disabled={!isEditing}
                />
              </div>
              <div className="form-group">
                <label>SSS Employer Number</label>
                <input
                  type="text"
                  value={companyInfo.sssNo}
                  onChange={(e) => setCompanyInfo({...companyInfo, sssNo: e.target.value})}
                  disabled={!isEditing}
                />
              </div>
              <div className="form-group">
                <label>PhilHealth Employer Number</label>
                <input
                  type="text"
                  value={companyInfo.philHealthNo}
                  onChange={(e) => setCompanyInfo({...companyInfo, philHealthNo: e.target.value})}
                  disabled={!isEditing}
                />
              </div>
              <div className="form-group">
                <label>Pag-IBIG Employer Number</label>
                <input
                  type="text"
                  value={companyInfo.pagibigNo}
                  onChange={(e) => setCompanyInfo({...companyInfo, pagibigNo: e.target.value})}
                  disabled={!isEditing}
                />
              </div>
              <div className="form-group">
                <label>Tax Type *</label>
                <select
                  value={companyInfo.taxType}
                  onChange={(e) => setCompanyInfo({...companyInfo, taxType: e.target.value as 'VAT' | 'NON-VAT'})}
                  disabled={!isEditing}
                >
                  <option value="VAT">VAT Registered</option>
                  <option value="NON-VAT">Non-VAT</option>
                </select>
              </div>
            </div>

            {/* Address Information */}
            <h4 style={{ marginBottom: '20px', color: '#1a237e', borderBottom: '2px solid #1a237e', paddingBottom: '10px' }}>
              Address Information
            </h4>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '20px', marginBottom: '30px' }}>
              <div className="form-group">
                <label>Street Address *</label>
                <input
                  type="text"
                  value={companyInfo.address}
                  onChange={(e) => setCompanyInfo({...companyInfo, address: e.target.value})}
                  disabled={!isEditing}
                />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '20px' }}>
                <div className="form-group">
                  <label>City *</label>
                  <input
                    type="text"
                    value={companyInfo.city}
                    onChange={(e) => setCompanyInfo({...companyInfo, city: e.target.value})}
                    disabled={!isEditing}
                  />
                </div>
                <div className="form-group">
                  <label>Province *</label>
                  <input
                    type="text"
                    value={companyInfo.province}
                    onChange={(e) => setCompanyInfo({...companyInfo, province: e.target.value})}
                    disabled={!isEditing}
                  />
                </div>
                <div className="form-group">
                  <label>Zip Code</label>
                  <input
                    type="text"
                    value={companyInfo.zipCode}
                    onChange={(e) => setCompanyInfo({...companyInfo, zipCode: e.target.value})}
                    disabled={!isEditing}
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Country</label>
                <input
                  type="text"
                  value={companyInfo.country}
                  onChange={(e) => setCompanyInfo({...companyInfo, country: e.target.value})}
                  disabled={!isEditing}
                />
              </div>
            </div>

            {/* Contact Information */}
            <h4 style={{ marginBottom: '20px', color: '#1a237e', borderBottom: '2px solid #1a237e', paddingBottom: '10px' }}>
              Contact Information
            </h4>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '30px' }}>
              <div className="form-group">
                <label>Phone *</label>
                <input
                  type="text"
                  value={companyInfo.phone}
                  onChange={(e) => setCompanyInfo({...companyInfo, phone: e.target.value})}
                  disabled={!isEditing}
                />
              </div>
              <div className="form-group">
                <label>Fax</label>
                <input
                  type="text"
                  value={companyInfo.fax}
                  onChange={(e) => setCompanyInfo({...companyInfo, fax: e.target.value})}
                  disabled={!isEditing}
                />
              </div>
              <div className="form-group">
                <label>Email *</label>
                <input
                  type="email"
                  value={companyInfo.email}
                  onChange={(e) => setCompanyInfo({...companyInfo, email: e.target.value})}
                  disabled={!isEditing}
                />
              </div>
              <div className="form-group">
                <label>Website</label>
                <input
                  type="text"
                  value={companyInfo.website}
                  onChange={(e) => setCompanyInfo({...companyInfo, website: e.target.value})}
                  disabled={!isEditing}
                />
              </div>
            </div>

            {/* Financial Settings */}
            <h4 style={{ marginBottom: '20px', color: '#1a237e', borderBottom: '2px solid #1a237e', paddingBottom: '10px' }}>
              Financial Settings
            </h4>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
              <div className="form-group">
                <label>Base Currency</label>
                <select
                  value={companyInfo.currency}
                  onChange={(e) => setCompanyInfo({...companyInfo, currency: e.target.value})}
                  disabled={!isEditing}
                >
                  <option value="PHP">Philippine Peso (PHP)</option>
                  <option value="USD">US Dollar (USD)</option>
                </select>
              </div>
              <div className="form-group">
                <label>Fiscal Year End (MM-DD)</label>
                <input
                  type="text"
                  value={companyInfo.fiscalYearEnd}
                  onChange={(e) => setCompanyInfo({...companyInfo, fiscalYearEnd: e.target.value})}
                  disabled={!isEditing}
                  placeholder="MM-DD"
                />
              </div>
            </div>
          </div>

          {/* Summary Cards */}
          <div style={{ marginTop: '30px' }}>
            <div className="summary-cards">
              <div className="summary-card">
                <div className="summary-icon">📋</div>
                <div className="summary-content">
                  <p className="summary-label">TIN</p>
                  <p className="summary-value" style={{ fontSize: '18px' }}>{companyInfo.tin}</p>
                </div>
              </div>
              <div className="summary-card">
                <div className="summary-icon">🏢</div>
                <div className="summary-content">
                  <p className="summary-label">Tax Type</p>
                  <p className="summary-value" style={{ fontSize: '18px', color: '#1a237e' }}>{companyInfo.taxType}</p>
                </div>
              </div>
              <div className="summary-card">
                <div className="summary-icon">📍</div>
                <div className="summary-content">
                  <p className="summary-label">Location</p>
                  <p className="summary-value" style={{ fontSize: '18px' }}>{companyInfo.city}, {companyInfo.province}</p>
                </div>
              </div>
              <div className="summary-card">
                <div className="summary-icon">💱</div>
                <div className="summary-content">
                  <p className="summary-label">Currency</p>
                  <p className="summary-value" style={{ fontSize: '18px' }}>{companyInfo.currency}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default CompanyProfile;
